import React from 'react';
import './ReadOnlyWrapper.scss';

export type IReadOnlyWrapperProps = {
    isReadOnly?: boolean;
    children?: React.ReactNode;
    className?: string;
};

const ReadOnlyWrapper = ({ children, isReadOnly, className }: IReadOnlyWrapperProps) => (
    <div data-testid="read-only-wrapper" className={`ReadOnlyWrapper ${className} ${isReadOnly ? 'ReadOnlyWrapper--disabled' : ''}`}>
        {children}
    </div>
);

export default ReadOnlyWrapper;
